// Canonical "fastest real lap" definition, shared by the lap list's ▲ badge
// and the sticky fastest-lap color feature so they can never disagree.
export function getBestLapTime(laps) {
  const timed = (laps || []).filter(l => !l.is_outlap && !l.is_inlap);
  return timed.length ? Math.min(...timed.map(l => l.lap_time_seconds)) : Infinity;
}

export function isBestLap(lap, bestTime) {
  return !!lap && !lap.is_outlap && !lap.is_inlap && (lap.lap_time_seconds - bestTime) < 0.001;
}
